import qs from 'qs';
import { useEffect, useState } from 'react';

import { fetchEventByCode } from '@general/api/eventAPI';
import useViewer from '@hooks/useViewer';

const queryParams = qs.parse(window.location.search.slice(1));

const useEventToRegisterSessionsFor = () => {
    const [eventToRegisterSessionsFor, setEventToRegisterSessionsFor] = useState();
    const { viewer } = useViewer();

    useEffect(() => {
        if (!viewer) {
            return;
        }

        if (!queryParams.event) {
            setEventToRegisterSessionsFor(null);
            return;
        }

        const eventAttended = viewer.events.find(event => event?.code === queryParams.event);
        if (!eventAttended) {
            setEventToRegisterSessionsFor(null);
            return;
        }

        (async () => {
            const eventData = await fetchEventByCode(queryParams.event);

            setEventToRegisterSessionsFor({
                code: queryParams.event,
                memberId: viewer.recordId,
                name: eventData.title,
                product_id: queryParams.event,
                sessions: [],
                sessionsOnly: true,
            });
        })();
    }, [viewer]);

    return { eventToRegisterSessionsFor };
};

export default useEventToRegisterSessionsFor;
